import { Injectable } from '@angular/core';
import { BaseStorageProvider } from '../base-storage.service';

@Injectable({ providedIn: 'root' })
export class LocalStorageService extends BaseStorageProvider {
  protected storage = localStorage;
}
